export default __webpack_public_path__ + "static/media/logo-2-circle.ae0a81c4.svg";